import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import App from '@opsbase/lib-system/App';
import { FeatureSets } from '@opsbase/lib-system/Features';
import AnalysisIcon from '@opsbase/web-icons/icons/AnalysisIcon';
import OpDefinitionIcon from '@opsbase/web-icons/icons/OpDefinitionIcon';
import PassIcon from '@opsbase/web-icons/icons/PassIcon';
import SettingsIcon from '@opsbase/web-icons/icons/SettingsIcon';
export const AppNavs = [
    {
        flag: FeatureSets[App.OPSBASE].TODO.key,
        link: Pages.TODO_OPS,
        pathname: '/todo',
        icon: PassIcon,
        label: () => i18n.t('todo'),
        dividerBelow: true,
        subnavs: [
            {
                flag: ((s, r) => r(FeatureSets[App.OPSBASE].TODO.key) &&
                    (!s.isTeamboard ||
                        r(FeatureSets[App.NATIVEBOARD].OPS.key))),
                link: Pages.TODO_OPS,
                label: () => i18n.t('ops'),
            },
            {
                flag: ((s, r) => r(FeatureSets[App.OPSBASE].TODO.key) &&
                    (!s.isTeamboard ||
                        r(FeatureSets[App.NATIVEBOARD].ISSUES.key))),
                link: Pages.TODO_ISSUES,
                label: () => i18n.t('issues'),
            },
        ],
    },
    {
        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
        link: Pages.OP_DEFINITIONS,
        pathname: '/operations',
        icon: OpDefinitionIcon,
        label: () => i18n.t('operations'),
        subnavs: [
            {
                flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
                link: Pages.OP_DEFINITIONS,
                label: () => i18n.t('operations'),
            },
            {
                flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
                link: Pages.WORKFLOWS,
                label: () => i18n.t('business-rules'),
            },
        ],
    },
    {
        flag: ((s, r) => r(FeatureSets[App.OPSBASE].OPS_LOG.key) ||
            r(FeatureSets[App.OPSBASE].ISSUES_LOG.key)),
        link: Pages.DASHBOARD,
        pathname: '/analytics',
        icon: AnalysisIcon,
        label: () => i18n.t('analytics'),
        dividerBelow: true,
        subnavs: [
            {
                flag: FeatureSets[App.OPSBASE].DASHBOARD.key,
                link: Pages.DASHBOARD,
                label: () => i18n.t('dashboard'),
            },
            {
                flag: FeatureSets[App.OPSBASE].OPS_LOG.key,
                link: Pages.OPS_LOG,
                label: () => i18n.t('ops'),
                dataType: DataType.OP,
            },
            {
                flag: FeatureSets[App.OPSBASE].ISSUES_LOG.key,
                link: Pages.ISSUES_LOG,
                label: () => i18n.t('issues'),
                dataType: DataType.ISSUE,
            },
        ],
    },
    {
        flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
        pathname: '/setup',
        link: Pages.PLACES,
        icon: SettingsIcon,
        label: () => i18n.t('settings'),
        children: [
            {
                flag: FeatureSets[App.OPSBASE].PLACES_MANAGEMENT.key,
                link: Pages.PLACES,
                label: () => i18n.t('places'),
            },
            {
                flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
                link: Pages.ASSETS,
                pathname: '/setup/assets',
                label: () => i18n.t('assets'),
                subnavs: [
                    {
                        flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
                        link: Pages.ASSETS,
                        label: () => i18n.t('assets'),
                    },
                ],
            },
            {
                flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
                link: Pages.STAFF,
                pathname: '/setup/users',
                label: () => i18n.t('users'),
                subnavs: [
                    {
                        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
                        link: Pages.STAFF,
                        label: () => i18n.t('staff'),
                    },
                    {
                        flag: FeatureSets[App.OPSBASE].TEAMBOARD_MANAGEMENT.key,
                        link: Pages.TEAMBOARDS,
                        label: () => i18n.t('teamboards'),
                    },
                ],
            },
            {
                flag: FeatureSets[App.OPSBASE].ORG_SETTINGS.key,
                link: Pages.OPTYPESETTINGS,
                pathname: '/setup/advanced',
                label: () => i18n.t('advanced'),
                children: [
                    {
                        flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
                        link: Pages.OPTYPESETTINGS,
                        pathname: '/setup/advanced/opsettings',
                        label: () => i18n.t('op-setup'),
                        subnavs: [
                            {
                                flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
                                link: Pages.OPTYPESETTINGS,
                                label: () => i18n.t('op-types'),
                            },
                            {
                                flag: FeatureSets[App.OPSBASE].OPS_SCORING.key,
                                link: Pages.OPGRADESETTINGS,
                                label: () => i18n.t('op-grades'),
                            },
                            {
                                flag: FeatureSets[App.OPSBASE].REPORT_MANAGEMENT.key,
                                link: Pages.OPREPORTSETTINGS,
                                label: () => i18n.t('op-savedviews'),
                            },
                            {
                                flag: FeatureSets[App.OPSBASE].QUESTIONBANK.key,
                                link: Pages.QUESTION_SETS,
                                label: () => i18n.t('question-bank'),
                            },
                            {
                                flag: FeatureSets[App.OPSBASE].OPS_MANAGEMENT.key,
                                link: Pages.ORG_TEMPLATES,
                                label: () => i18n.t('op-templates'),
                            },
                        ],
                    },
                    {
                        flag: FeatureSets[App.OPSBASE].ISSUES_LOG.key,
                        link: Pages.ISSUETYPESETTINGS,
                        pathname: '/setup/advanced/issuesettings',
                        label: () => i18n.t('issue-setup'),
                        subnavs: [
                            {
                                flag: FeatureSets[App.OPSBASE].ISSUES_LOG.key,
                                link: Pages.ISSUETYPESETTINGS,
                                label: () => i18n.t('issue-types'),
                            },
                            {
                                flag: FeatureSets[App.OPSBASE].ISSUES_LOG.key,
                                link: Pages.ISSUEFLAGSETTINGS,
                                label: () => i18n.t('issue-flags'),
                            },
                            {
                                flag: FeatureSets[App.OPSBASE].REPORT_MANAGEMENT.key,
                                link: Pages.ISSUEREPORTSETTINGS,
                                label: () => i18n.t('issue-savedviews'),
                            },
                        ],
                    },
                    {
                        flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
                        link: Pages.ASSETTYPESETTINGS,
                        pathname: '/setup/advanced/assetsettings',
                        label: () => i18n.t('asset-setup'),
                        subnavs: [
                            {
                                flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
                                link: Pages.ASSETTYPESETTINGS,
                                label: () => i18n.t('asset-types'),
                            },
                            {
                                flag: FeatureSets[App.OPSBASE].ASSET_MANAGEMENT.key,
                                link: Pages.ASSETCUSTOMFIELDS,
                                label: () => i18n.t('custom-fields'),
                            },
                        ],
                    },
                    {
                        flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
                        link: Pages.POSITIONS,
                        label: () => i18n.t('user-setup'),
                        pathname: '/setup/advanced/usersettings',
                        subnavs: [
                            {
                                flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
                                link: Pages.POSITIONS,
                                label: () => i18n.t('positions'),
                            },
                            {
                                flag: FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT.key,
                                link: Pages.TEAMS,
                                label: () => i18n.t('teams'),
                            },
                        ],
                    },
                    {
                        flag: FeatureSets[App.OPSBASE].REPORT_MANAGEMENT.key,
                        link: Pages.REPORTSETTINGS,
                        label: () => i18n.t('report-settings'),
                        pathname: '/setup/advanced/reportsettings',
                        subnavs: [
                            {
                                flag: FeatureSets[App.OPSBASE].REPORT_MANAGEMENT.key,
                                link: Pages.REPORTSETTINGS,
                                label: () => i18n.t('settings'),
                            },
                        ],
                    },
                    {
                        flag: FeatureSets[App.OPSBASE].INTEGRATIONS_API.key,
                        link: Pages.INTEGRATIONS_API,
                        label: () => i18n.t('integrations'),
                        pathname: '/setup/advanced/integrations',
                        subnavs: [
                            {
                                flag: FeatureSets[App.OPSBASE].INTEGRATIONS_API.key,
                                link: Pages.INTEGRATIONS_API,
                                label: () => i18n.t('api'),
                            },
                            {
                                flag: FeatureSets[App.OPSBASE].INTEGRATIONS_IOT.key,
                                link: Pages.INTEGRATIONS_IOT,
                                label: () => i18n.t('iot'),
                            },
                            {
                                flag: FeatureSets[App.OPSBASE].INTEGRATIONS_IQM.key,
                                link: Pages.INTEGRATIONS_IQM,
                                label: () => i18n.t('iqm'),
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
